module.exports = __webpack_public_path__ + "static/media/user.698026a5.svg";